import React, { useState } from "react";
import "./login.css";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(
        "https://kol.cubixsystems.com/api/login.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        localStorage.setItem("auth", "loggedin");
        navigate("/Dashboard");
      } else {
        setMessage(result.message || "Invalid username or password");
      }
    } catch (error) {
      setMessage("Unable to connect to the server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      {/* =========================================
          LEFT LOGIN PANEL
      ========================================= */}

      <div className="login-panel">

        <div className="login-container">

          {/* Brand */}
          <div className="login-brand">

            <div className="login-logo">
              <i className="fa fa-stethoscope"></i>
            </div>

            <div>
              <div className="brand-name">
                MediCare <span>2.0</span>
              </div>

              <div className="brand-subtitle">
                Healthcare Management System
              </div>
            </div>

          </div>


          {/* Welcome */}
          <div className="login-heading">

            {/* <span className="welcome-label">
              WELCOME BACK
            </span> */}

            <h1 style={{fontSize:'18pt',fontWeight:'500'}}>
              Kolath Medical Centre
              
            </h1>
            <h1 style={{fontSize:'25pt',fontWeight:'600',marginTop:'15px'}}>
               <span >Login</span>
            </h1>

          
          </div>


          {/* Login Form */}
          <form
            onSubmit={handleSubmit}
            className="modern-login-form"
          >

            {/* Username */}
            <div className="input-group-modern">

              <label>
                Username
              </label>

              <div className="input-wrapper">

                <i className="fa fa-user input-icon"></i>

                <input
                  type="text"
                  name="username"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  autoComplete="username"
                />

              </div>

            </div>


            {/* Password */}
            <div className="input-group-modern">

              <label>
                Password
              </label>

              <div className="input-wrapper">

                <i className="fa fa-lock input-icon"></i>

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowPassword(!showPassword)
                  }
                >
                  <i
                    className={
                      showPassword
                        ? "fa fa-eye-slash"
                        : "fa fa-eye"
                    }
                  ></i>
                </button>

              </div>

            </div>


            {/* Error */}
            {message && (
              <div className="login-message">

                <i className="fa fa-exclamation-circle"></i>

                <span>{message}</span>

              </div>
            )}


            {/* Login Button */}
            <button
              type="submit"
              className="modern-login-button"
              disabled={loading}
            >

              {loading ? (
                <>
                  <i className="fa fa-spinner fa-spin"></i>
                  Signing in...
                </>
              ) : (
                <>
                  Sign In
                  <i className="fa fa-arrow-right"></i>
                </>
              )}

            </button>

          </form>


          {/* Security */}
          <div className="login-security">

            <i className="fa fa-shield"></i>

            <span>
              Secure & protected healthcare portal
            </span>

          </div>


          {/* Copyright */}
          <div className="login-copyright">
            © {new Date().getFullYear()} Kolath Medical Centre
          </div>

        </div>

      </div>


      {/* =========================================
          RIGHT BRAND PANEL
      ========================================= */}

      <div className="login-visual" style={{backgroundImage:'url(./images/bg.avif)'}}>

        <div className="visual-overlay"></div>

        {/* Decorative circles */}
        <div className="visual-circle circle-a"></div>
        <div className="visual-circle circle-b"></div>
        <div className="visual-circle circle-c"></div>


        <div className="visual-content">

          {/* Top badge */}
          <div className="medical-badge">

            <span className="badge-dot"></span>

            <span>
              HEALTHCARE MANAGEMENT
            </span>

          </div>


          <h2 style={{color:'white',fontSize:'25pt'}}>
            Better Care.
           &nbsp;
            <span style={{fontWeight:'400',fontSize:'28pt'}}>Better Management.</span>
          </h2>

          {/* <p>
            A smarter way to manage patient information,
            appointments and medical visits.
          </p> */}


          {/* Features */}
          <div className="feature-list">

            <div className="feature-item">

              <div className="feature-icon">
                <i className="fa fa-users"></i>
              </div>

              <div>
                <strong>
                  Patient Management
                </strong>

                <span>
                  Easily manage patient records
                </span>
              </div>

            </div>


            <div className="feature-item">

              <div className="feature-icon">
                <i className="fa fa-calendar"></i>
              </div>

              <div>
                <strong>
                  Visit Management
                </strong>

                <span>
                  Track every patient visit
                </span>
              </div>

            </div>


            <div className="feature-item">

              <div className="feature-icon">
                <i className="fa fa-line-chart"></i>
              </div>

              <div>
                <strong>
                  Smart Dashboard
                </strong>

                <span>
                  Everything at a glance
                </span>
              </div>

            </div>

          </div>

        </div>


        {/* Bottom company */}
        <div className="visual-footer">

          <span>
            Powered by
          </span>

          <strong>
            Cubix Software Solutions
          </strong>

        </div>

      </div>

    </div>
  );
}